// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PAGE */
.garden-page {
    padding: 20px;
}

/* HEADER */
.users-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.users-header-logo h1 {
    font-size: 28px;
    font-weight: 600;
}

/* TABLE */
.users-table-wrapper {
    background: var(--card-bg);
    border-radius: 12px;
    padding: 20px;
    border: 1px solid var(--border-color);
    margin-bottom: 30px;
}

.users-table {
    width: 100%;
    border-collapse: collapse;
}

.users-table th {
    text-align: left;
    padding: 12px;
    font-weight: 600;
    border-bottom: 1px solid var(--border-color);
}

.users-table td {
    padding: 12px;
    border-bottom: 1px solid var(--border-color);
}

.users-table .actions button {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 18px;
    transition: 0.2s;
}

.users-table .actions button:hover {
    transform: scale(1.2);
}

/* Lignes vides */
.empty-row td {
    height: 40px;
    opacity: 0.2;
}

/* DARK MODE */
.dashboard.dark .users-table-wrapper {
    background: rgba(255, 255, 255, 0.05);
}

.dashboard.dark .users-table td,
.dashboard.dark .users-table th {
    color: white;
}

.users-table-wrapper.archived {
    opacity: 0.6;
    filter: grayscale(40%);
}

.archived-row td {
    font-style: italic;
}

.reminders-box {
    background: rgba(255,255,255,0.15);
    border: 1px solid rgba(255,255,255,0.25);
    padding: 15px;
    border-radius: 10px;
    margin-bottom: 20px;
    backdrop-filter: blur(6px);
    list-style: none;
}

.reminder-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    border-radius: 6px;
    margin: 6px 0;
    padding: 6px 10px;
    border-radius: 6px;
    list-style: none;
}

.reminder-icon {
    font-size: 18px;
}

.reminder-rempotage {
    background: rgba(255, 200, 0, 0.2);
    border-left: 4px solid #ffcc00;
}

.reminder-pot {
    background: rgba(0, 150, 255, 0.2);
    border-left: 4px solid #0096ff;
}

.reminder-note {
    background: rgba(0, 200, 0, 0.2);
    border-left: 4px solid #00cc44;
}

.reminder-arrosage {
    background: rgba(0, 180, 255, 0.18);
    border-left: 4px solid #00b4ff;
}
.reminder-parasites {
    background: rgba(255, 80, 80, 0.18);
    border-left: 4px solid #ff5050;
}
.reminder-repiquage {
    background: rgba(80, 200, 120, 0.18);
    border-left: 4px solid #50c878;
}
.reminder-temperature {
    background: rgba(150, 200, 255, 0.18);
    border-left: 4px solid #66aaff;
}



`, "",{"version":3,"sources":["webpack://./src/styles/TomatePoivron.css"],"names":[],"mappings":"AAAA,SAAS;AACT;IACI,aAAa;AACjB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,UAAU;AACV;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,4CAA4C;AAChD;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,iBAAiB;AACjB;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA,cAAc;AACd;IACI,qCAAqC;AACzC;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,mCAAmC;IACnC,8BAA8B;AAClC;AACA;IACI,mCAAmC;IACnC,8BAA8B;AAClC;AACA;IACI,oCAAoC;IACpC,8BAA8B;AAClC;AACA;IACI,qCAAqC;IACrC,8BAA8B;AAClC","sourcesContent":["/* PAGE */\r\n.garden-page {\r\n    padding: 20px;\r\n}\r\n\r\n/* HEADER */\r\n.users-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.users-header-logo h1 {\r\n    font-size: 28px;\r\n    font-weight: 600;\r\n}\r\n\r\n/* TABLE */\r\n.users-table-wrapper {\r\n    background: var(--card-bg);\r\n    border-radius: 12px;\r\n    padding: 20px;\r\n    border: 1px solid var(--border-color);\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.users-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.users-table th {\r\n    text-align: left;\r\n    padding: 12px;\r\n    font-weight: 600;\r\n    border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.users-table td {\r\n    padding: 12px;\r\n    border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.users-table .actions button {\r\n    background: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n    transition: 0.2s;\r\n}\r\n\r\n.users-table .actions button:hover {\r\n    transform: scale(1.2);\r\n}\r\n\r\n/* Lignes vides */\r\n.empty-row td {\r\n    height: 40px;\r\n    opacity: 0.2;\r\n}\r\n\r\n/* DARK MODE */\r\n.dashboard.dark .users-table-wrapper {\r\n    background: rgba(255, 255, 255, 0.05);\r\n}\r\n\r\n.dashboard.dark .users-table td,\r\n.dashboard.dark .users-table th {\r\n    color: white;\r\n}\r\n\r\n.users-table-wrapper.archived {\r\n    opacity: 0.6;\r\n    filter: grayscale(40%);\r\n}\r\n\r\n.archived-row td {\r\n    font-style: italic;\r\n}\r\n\r\n.reminders-box {\r\n    background: rgba(255,255,255,0.15);\r\n    border: 1px solid rgba(255,255,255,0.25);\r\n    padding: 15px;\r\n    border-radius: 10px;\r\n    margin-bottom: 20px;\r\n    backdrop-filter: blur(6px);\r\n    list-style: none;\r\n}\r\n\r\n.reminder-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    padding: 6px 10px;\r\n    border-radius: 6px;\r\n    margin: 6px 0;\r\n    padding: 6px 10px;\r\n    border-radius: 6px;\r\n    list-style: none;\r\n}\r\n\r\n.reminder-icon {\r\n    font-size: 18px;\r\n}\r\n\r\n.reminder-rempotage {\r\n    background: rgba(255, 200, 0, 0.2);\r\n    border-left: 4px solid #ffcc00;\r\n}\r\n\r\n.reminder-pot {\r\n    background: rgba(0, 150, 255, 0.2);\r\n    border-left: 4px solid #0096ff;\r\n}\r\n\r\n.reminder-note {\r\n    background: rgba(0, 200, 0, 0.2);\r\n    border-left: 4px solid #00cc44;\r\n}\r\n\r\n.reminder-arrosage {\r\n    background: rgba(0, 180, 255, 0.18);\r\n    border-left: 4px solid #00b4ff;\r\n}\r\n.reminder-parasites {\r\n    background: rgba(255, 80, 80, 0.18);\r\n    border-left: 4px solid #ff5050;\r\n}\r\n.reminder-repiquage {\r\n    background: rgba(80, 200, 120, 0.18);\r\n    border-left: 4px solid #50c878;\r\n}\r\n.reminder-temperature {\r\n    background: rgba(150, 200, 255, 0.18);\r\n    border-left: 4px solid #66aaff;\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
